import React from "react";
import {moment} from "../../../../../vendor";
import t from "../../../helpers/t";
import hljs from 'highlight.js';
import 'highlight.js/styles/github.css';

function syntaxHighlight(json) {
    //console.log(typeof json);
    try {
        json = JSON.stringify(JSON.parse(json), undefined, '\t');

        //console.log(json);
        json = json.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
        let jnew = json.replace(/("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g, function (match) {
            var cls = 'number';
            if (/^"/.test(match)) {
                if (/:$/.test(match)) {
                    cls = 'key';
                } else {
                    cls = 'string';
                }
            } else if (/true|false/.test(match)) {
                cls = 'boolean';
            } else if (/null/.test(match)) {
                cls = 'null';
            }
            return '<span class="' + cls + '">' + match + '</span>';
        });
        // console.log(jnew);
        return jnew;
    } catch (e) {
        return json;
    }
}
const _showPopUp = (text,title,type) => {
    //console.log(beautify(text, null, 4));
    if(type === 'json') {
        text = syntaxHighlight(text);//beautify(JSON.parse(text), null, '  ');
    }
    /*let data = JSON.parse(text);
    data = JSON2.stringify(JSON2.decycle(data), null, '  ');*/
    //console.log(text);
  //  console.log(text);
    let output = "<html><head>"+
        '<link href="https://fonts.googleapis.com/css?family=Open+Sans:400,600" rel="stylesheet">'+
        '<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/highlight.js/11.7.0/styles/default.min.css">'+
        '<script>hljs.highlightAll();</script>'+
        "<title>"+t(title)+"</title>"+
        '<style type="text/css">'+
        'body { font-family: "Open Sans",Helvetica,Arial,sans-serif; background-color: white } '+
        "hode, html, table, thead { width: 100%; } "+
        "h4 { font-size: 18px; } "+
        ".printSpacer { height:100px; } "+
        ".key { color: red; } " +
        ".string { color: darkblue; } " +
        ".number { color: seagreen; } " +
        ".boolean { color: navy;font-weight: bold; } " +
        ".null { color: navy;font-weight: bold; } " +
        "</style> </head><div><pre>"+text +`</pre></div></body>
            </html>`;
    let rV = -1; // Return value assumes failure.

    if (navigator.appName == 'Microsoft Internet Explorer' || navigator.appName == 'Netscape') {

        var uA = navigator.userAgent;
        var rE = new RegExp("MSIE ([0-9]{1,}[\.0-9]{0,})");

        if (rE.exec(uA) != null) {
            rV = parseFloat(RegExp.$1);
        }
        else if (!!navigator.userAgent.match(/Trident.*rv\:11\./)) {
            rV = 11;
        }
    }

    const isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
    const newWindow = window.open('', '', 'height=700,width=1374');

    newWindow.document.body.innerHTML = '';
    newWindow.document.body.innerHTML = output;
    if (rV >=10 || isChrome) {
        newWindow.focus(); // necessary for IE >= 10*
    } else {
        // e.g. Firefox
        setTimeout(() => {
            newWindow.opener.focus();
        }, 0);
    }
    return true;
}

const AppErrorListItem = (props) => {
    const error = props.error;

    return (
        <>
        <div className={"inb-c-item inb-c-item--error row hide-for-small-only"}  key={"div_row_"+error.id+"_standard"}>
            <div className="large-1 medium-1 small-2 column  padding-1" id="error-id" key={"div_error_id_"+error.id}>
                <span title="ID">
                    {error.id}
                </span>
             </div>
            <div className="large-1 medium-1 small-1 column" id="reservation_id" key={"div_error_reservation_id_"+error.id}>
                <span title="Reservation ID" className="text-nowrap">
                    {error.reservation_id}
                </span>
            </div>
            <div className="large-1 medium-1 small-1 column" id="inb-order_id" title="Order ID" key={"div_error_order_id_"+error.id}>
                {error.order_id}
            </div>
            <div className="large-1 medium-1 small-1 column" id="inb-client_id" title="Client ID" key={"div_error_client_id_"+error.id}>
                {error.client_id}
            </div>
            <div className="large-1 medium-2 small-2 column" title="User ID" style={{minHeight:"40px"}} key={"div_error_user_id_"+error.id}>
                <span className="text-nowrap">
                        {error.created_by_name}
                </span>
            </div>
            <div className="large-1 medium-1 small-1 medium-offset-0 column" id="inb-type" key={"div_error_type_"+error.id}>
                <span className="text-nowrap">
                    {error.type}
                </span>
            </div>
            <div className="large-1 medium-1 small-1 medium-offset-0 column" id="inb-app_screen_title" key={"div_error_app_screen_title_"+error.id}>
                <span className="text-nowrap">
                    {error.app_screen_title}
                </span>
            </div>
            <div className="large-1 medium-1 small-1 medium-offset-0 column" id="inb-call_function" key={"div_error_call_function_"+error.id}>
                <span className="text-nowrap">
                    {error.call_function}
                </span>
            </div>
            <div className="large-1 medium-1 small-2 medium-offset-0 column" id="inb-error_text" key={"div_error_error_text_"+error.id}>
                <span className="text-nowrap">
                    <a href="#" onClick={() => _showPopUp(error.error_text, 'error_text', 'json')}>{t('show_${a}',{a:t('error_text')})}</a>
                </span>
            </div>
            <div className="large-1 medium-1 small-2 medium-offset-0 column" id="inb-error_text" key={"div_error_additional_info_"+error.id}>
                <span className="text-nowrap">
                    <a href="#" onClick={() => _showPopUp(error.additional_info, 'additional_info', 'json')}>{t('show_${a}',{a:t('additional_info')})}</a>
                </span>
            </div>
            <div className="large-1 medium-1 small-1 medium-offset-0 column" id="inb-created" key={"div_error_created_"+error.id}>
                <span className="text-nowrap">
                    {moment(error.created).format('DD.MM.YYYY hh:mm')}
                </span>
            </div>









            {/*  small   */}

            {/*<div className={"inb-c-item inb-c-item--resource row show-for-small-only" + (resource.status === 'active' ? ' not-marked' : (resource.status === 'inactive' ? ' gray-marked' : ' red-marked'))}  key={"div_row_"+resource.id}>
                <div className="medium-1 small-7 column inb-order-big padding-1" id="order-id" title="ID"  key={"div_resource_id_"+resource.id}><Span>{props.hasResourceNbr?resource.resource_nbr:resource.id}</Span></div>
                <div className="medium-3 small-7 column inb-order-big" id="name-bike" title="Bezeichnung" key={"div_resource_name_"+resource.id}><span className="text-nowrap">{props.resource.name}</span><br/><div title={t('description')} style={{textAlign:'left',fontSize: ".8125rem", fontWeight: "normal"}}>{note}</div></div>
                <div className="medium-2 small-7 column" id="inb-contingent" title="Kontingent" key={"div_resource_contingent_"+resource.id}>{resource.contingent_id_name}{showContingentLocationName ? " | " + resource.contingent_id_location_name : ""}</div>
                <div className= "medium-4 small-12 inb-group-item hide-for-small-only">
                    <div className="medium-6 small-6 column" title="Standort" style={ resource.location_id == null ? {color: "red"} : {}}>
                        {resource.location_id_name}
                        <br/>
                        {link}
                    </div>
                    <div className="medium-3 small-3 medium-offset-0 column padding-1" title="Verfügbarkeit">
                        <AvailIcon
                            Value={resource.checkedInStatus}
                            Title={t(resource.checkedInStatus,null,'capital')}
                            Reservation={resource.checkedInStatus === "inprogress" ? resource.reservation.id : null}
                            key={"icon_resource_avail_"+resource.id}
                            Resource={resource.id}
                            setInitialized={props.setInitialized}
                        />
                        /> <Div2> {resource.checkInAmount}</Div2>  </div>
                    <div className="medium-3 small-3 medium-offset-0 column" title="Akkus">
                        <Akkus
                            resource={resource}
                            switchLock={props.switchLock}
                            sendSignalSound={props.sendSignalSound}
                            toggleTheft={props.toggleTheft}
                            locked={props.lockPending && props.lockResource === resource.id}/>
                    </div>
                </div>


                <div className="medium-2 small-7 column show-for-small-only" title="Standort" style={ resource.location_id == null ? {minHeight:"40px",color: "red"} : {minHeight:"40px"}} key={"div_resource_location_"+resource.id}>
                    {props.resource.location_id_name}
                </div>
                <div className="medium-4 small-12 inb-group-item" id="group-item-3" key={"div_resource_buttons_group_"+resource.id}>
                    <div className="medium-7 small-8 medium-offset-0" id="inb-group-status-time">
                        <div className="medium-6 small-6" id="status" title="Status" style={{paddingTop:"17px"}}>
                            {rbac.hasPermission('editStatus') &&
                            <select
                                className={props.index % 2 === 1 ? 'inbooma-select-box__input second-select' : 'inbooma-select-box__input'}
                                name="status"
                                onChange={e => props.onChangeStatus(e, resource)}
                                key={"select_resource_status_"+resource.id}
                                value={resource.status === null ? '' : resource.status}
                                placeholder={t('select_${a}', {a: t('status')})}>
                                {['active', 'inactive', 'defect'].map(status => {
                                    return (
                                        <>
                                            <option key={status+resource.id} value={status}>{t(status)}</option>
                                        </>
                                    )
                                })}
                            </select>
                            }
                            {!rbac.hasPermission('editStatus') &&
                            <span>{t(props.resource.status)}</span>
                            }
                        </div>
                        <div className="medium-6 small-6 column datetime-booking" title="Modifiziert am">
                            {moment(resource.modified).format('DD.MM.YY HH:mm')}
                            <br/>
                            <div style={{textAlign:'left',paddingTop:"5px"}}>{act2}</div>
                        </div>
                    </div>

                    <div className="medium-5 small-4 medium-offset-0 column item-button-group padding-05" key={"div_resource_edit_"+resource.id}>
                        <div className="medium-12 small-3 medium-offset-0 column" id="group-icon-one">
                            {rbac.hasPermission('editResource') &&
                            <div className="button-container-resources left" key={"div_resource_button_container_edit_"+resource.id}>
                                <a
                                    href={"#"}
                                    title={t('edit')}
                                    key={"a_resource_edit_"+resource.id}
                                    data-inb-action-link="edit">
                                    <button type="button" className="inb-round-btn hollow round float-left" key={"a_button_resource_edit_"+resource.id} onClick={() => onOpen()}>
                                        <div className="inb-fi-edit"> </div>
                                    </button>
                                </a>
                            </div>
                            }
                            {rbac.hasPermission('write') &&
                            <div className="button-container-resources"  key={"div_resource_button_container_delete_"+resource.id}>
                                <a
                                    href="#"
                                    className="inb-reservation__pdf2"
                                    title={t('delete')}
                                    key={"a_resource_delete_"+resource.id}
                                    data-inb-action-link="delete">
                                    <button type="button" className="inb-round-btn hollow round float-left"
                                            key={"a_button_resource_delete_"+resource.id}
                                            onClick={() => props.onRemoveResource(resource)}>
                                        <div className="inb-fi-remove"> </div>
                                    </button>
                                </a>
                            </div>
                            }
                            <div className="button-container-resources"  key={"div_resource_button_container_qr_"+resource.id}>
                                <a
                                    href="#"
                                    title={t('getQRCode')}
                                    key={"a_resource_qr_"+resource.id}
                                    data-inb-action-link="delete">
                                    <button type="button" className="inb-round-btn hollow round float-left"
                                            key={"a_button_resource_qr_"+resource.id}
                                            onClick={() => props.onGetQRCodeHandler(resource)}>
                                        <div className="inb-fi-qrcode"> </div>
                                    </button>
                                </a>
                            </div>
                        </div>
                        <div className="medium-12 small-3 medium-offset-0 column show-for-small-only" id="group-icon-two">
                            {link ?
                                <div id="mapIcon">
                                    {link}
                                </div>
                                : ""}
                            <div title="Verfügbarkeit" id="availCheckedIn">
                                <AvailIcon
                                    Value={resource.checkedInStatus}
                                    Title={t(resource.checkedInStatus,null,'capital')}
                                    Reservation={resource.checkedInStatus === "inprogress" ? resource.reservation.id : null}
                                    key={"icon_resource_avail_"+resource.id}
                                    Resource={resource.id}
                                    setInitialized={props.setInitialized}
                                />
                                 <Div2> {resource.checkInAmount}</Div2>
                            </div>
                        </div>
                        <div className="medium-12 small-3 medium-offset-0 column show-for-small-only" id="group-icon-three" title="Akkus">
                            <Akkus
                                resource={resource}
                                switchLock={props.switchLock}
                                sendSignalSound={props.sendSignalSound}
                                toggleTheft={props.toggleTheft}
                                showPercent={false}
                                locked={props.lockPending && props.lockResource === resource.id}/>
                        </div>
                    </div>
                </div>
*/}
            </div>
            </>
    );
}

export default AppErrorListItem;